import { c as _c } from "react/compiler-runtime";
import { Dispatch, SetStateAction } from 'react';
import SearchSuggestionList from '@/app/[locale]/(worlds)/components/SearchSuggestionList';
import { useWorldSearchContext } from '@/context/WorldSearchContext';
type MobileSearchSuggestionsProps = {
  showSuggestions?: boolean;
  setIsSearchCleared: Dispatch<SetStateAction<boolean>>;
};
export default function MobileSearchSuggestions(t0) {
  const $ = _c(6);
  const {
    showSuggestions: t1,
    setIsSearchCleared
  } = t0;
  const showSuggestions = t1 === undefined ? true : t1;
  const {
    startSearch
  } = useWorldSearchContext();
  let t2;
  if ($[0] !== setIsSearchCleared || $[1] !== startSearch) {
    t2 = value => {
      startSearch(value, {
        onAfterNavigate() {
          setIsSearchCleared(false);
        }
      });
    };
    $[0] = setIsSearchCleared;
    $[1] = startSearch;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleSearch = t2;
  let t3;
  if ($[3] !== handleSearch || $[4] !== showSuggestions) {
    t3 = <SearchSuggestionList showSuggestions={showSuggestions} onSearchClick={handleSearch} />;
    $[3] = handleSearch;
    $[4] = showSuggestions;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}